module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-hh.4b45496b.png";